import { createSlice } from '@reduxjs/toolkit';
import {logout} from "./authenticationSlice";

const statusSlice = createSlice({
    name: 'status',
    initialState: {
        status: 'init'
    },
    reducers: {
        error: (state, action) => {
            state.error = action.payload;
        },
        detailedError: (state, action) => {
            state.error = action.payload?.errorDescription;
            state.errorHeader = action.payload?.errorMessage;
        },
        clearError: (state) => {
            state.error = undefined;
            state.errorHeader = undefined;
        },
        changeStatus: (state, action) => {
            state.status = action.payload;
        }
    },
    extraReducers(builder) {
        // second argument will update the state
        builder.addCase(logout, (state) => {
            state.status = "init";
        });
    }
});

export const {
    error,
    detailedError,
    clearError,
    changeStatus
} = statusSlice.actions;

export default statusSlice.reducer;
